module.exports = __webpack_public_path__ + "img/Skirt-Front-B7-Da-Ha-Ia.f973b2d0.png";